import { render, staticRenderFns } from "./CotacaoB.vue?vue&type=template&id=aabc0f02&scoped=true"
import script from "./CotacaoB.vue?vue&type=script&lang=js"
export * from "./CotacaoB.vue?vue&type=script&lang=js"
import style0 from "./CotacaoB.vue?vue&type=style&index=0&id=aabc0f02&prod&lang=css"
import style1 from "./CotacaoB.vue?vue&type=style&index=1&id=aabc0f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabc0f02",
  null
  
)

export default component.exports